// 服务端 storage 空实现
// SSR 渲染时(data()/fetch()/asyncData()/created() 中)大量页面直接读写
// sessionStorage/localStorage,Node 里没有这两个全局对象会导致渲染崩溃。
// 这里在服务端挂一个 no-op 实现:读一律返回 null(渲染"未登录"态),
// 写一律忽略。客户端不受影响(插件仅在 process.server 下生效)。
// 客户端 hydration 后 created/mounted 会重新执行,真实 storage 数据照常生效。

if (process.server) {
  const noopStore = {
    getItem: () => null,
    setItem() {},
    removeItem() {},
    clear() {},
    key: () => null,
    length: 0,
  };
  global.sessionStorage = noopStore;
  global.localStorage = noopStore;
}
